import React, { useEffect, useState } from 'react'
import { useTransition, animated } from '@react-spring/web'
import Tilt from 'react-parallax-tilt'



export default function TiltCrossfade({images}) {
  const [activeIndex, setActiveIndex] = useState(0)

  // Preload all images to avoid flicker
  useEffect(() => {
    images?.forEach((src) => {
      const img = new Image()
      img.src = src
    })
  }, [])

  const transitions = useTransition(activeIndex, {
    from: { opacity: 0, transform: 'scale(1.05)' },
    enter: { opacity: 1, transform: 'scale(1)' },
    leave: { opacity: 0, transform: 'scale(0.95)' },
    config: { duration: 1200 },
    exitBeforeEnter: false,
    keys: (index) => index,
  })

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % images.length)
    }, 1500)
    return () => clearInterval(interval)
  }, [])

  return (
    <Tilt
      tiltMaxAngleX={35}
      tiltMaxAngleY={35}
      perspective={800}
      transitionSpeed={1000}
      scale={1.05}
      style={{
        width: '700px',
        height: '500px',
        overflow: 'hidden',
        borderRadius:'30px'
      }}
    >
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
        }}
      >
        {transitions((style, index) => (
          <animated.img
          preload="auto"
            key={index}
            src={images[index]}
            style={{
              ...style,
              width: '100%',
              height: '100%',
              borderRadius:'30px',
              objectFit: 'contain',
              position: 'absolute',
              top: 0,
              left: 0,
            }}
          />
        ))}
      </div>
    </Tilt>
  )
}
